import { render, staticRenderFns } from "./CardsHome.vue?vue&type=template&id=b3378d0a&scoped=true"
import script from "./CardsHome.vue?vue&type=script&lang=js"
export * from "./CardsHome.vue?vue&type=script&lang=js"
import style0 from "./CardsHome.vue?vue&type=style&index=0&id=b3378d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3378d0a",
  null
  
)

export default component.exports